import { createFileRoute } from "@tanstack/react-router";

import PermissionSimulatorAdmin from "@/components/PermissionSimulatorAdmin";

// Passthrough, like every admin route: the console component owns everything, and
// `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/permission-simulator")({
  component: PermissionSimulatorAdmin,
});
